module.exports = __webpack_public_path__ + "media/images/post/bgi-post-travel2-a25db596bc346045db373f54eecda32f.jpg";